import * as React from "react";
import { filterOptions } from "../../../../Home/common/filter_drone_section/components/filter/components/filter_options";
import CategoryCard from "./category_card";
import { DroneDTO } from "../../../../../store/drone_slice";

interface CategoriesProps {
  droneData: Pick<DroneDTO, 'categories'>;
  updateDroneData: (newData: Partial<Pick<DroneDTO, 'categories'>>) => void;
}

const Categories: React.FC<CategoriesProps> = ({
  droneData,
  updateDroneData,
}) => {
  const [selectedCategories, setSelectedCategories] = React.useState<string[]>(
    droneData.categories || [],
  );

  // Add useEffect to update internal state when prop changes
  React.useEffect(() => {
    // Only update if the prop is different from the current state
    // to avoid potential infinite loops if updateDroneData caused immediate prop change
    if (droneData.categories && !areArraysEqual(droneData.categories, selectedCategories)) {
      setSelectedCategories(droneData.categories || []);
    }
  }, [droneData.categories]); // Dependency array includes the prop to watch

  // Helper function to compare arrays
  const areArraysEqual = (arr1: string[], arr2: string[]) => {
    if (arr1.length !== arr2.length) return false;
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();
    return sortedArr1.every((val, idx) => val === sortedArr2[idx]);
  };

  const handleSelectCategory = (id: string) => {
    let newCategories: string[];
    
    if (selectedCategories.includes(id)) {
      // Remove category if already selected
      newCategories = selectedCategories.filter(catId => catId !== id);
    } else {
      // Add category if not already selected
      newCategories = [...selectedCategories, id];
    }
    
    setSelectedCategories(newCategories);
    updateDroneData({ categories: newCategories });
  };

  return (
    <div className="p-4 max-w-screen-lg mx-auto font-ubuntu text-primary">
      <h2 className="text-2xl font-medium mb-6 text-left">
        Choose the categories you want
        <br /> your drone to be featured in
      </h2>
      <p className="text-sm text-gray-600 mb-4">You can select multiple categories</p>
      <div className="flex flex-wrap justify-center sm:justify-start gap-x-[29px] gap-y-6">
        {filterOptions.map((option) => (
          <div
            key={option.id}
            className="w-full sm:w-[calc(50%-29px)] md:w-[calc(33.333%-29px)] lg:w-[calc(25%-29px)] max-w-[220px]"
          >
            <CategoryCard
              id={option.id}
              name={option.name}
              icon={option.darkIcon}
              isSelected={selectedCategories.includes(option.id)}
              onSelect={handleSelectCategory}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Categories;
